if (!customElements.get('phloe-buy-box')) {
  class PhloeBuyBox extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;

      this.config = JSON.parse(this.querySelector('[data-pbb-config]').textContent);
      const sectionId = this.dataset.sectionId;
      this.names = {
        qty: `pbb-qty-${sectionId}`,
        size: `pbb-size-${sectionId}`,
        purchase: `pbb-purchase-${sectionId}`
      };

      this.form = this.querySelector('form');
      this.idInput = this.form.querySelector('[name="id"]');
      this.qtyInput = this.form.querySelector('[name="quantity"]');
      this.planInput = this.form.querySelector('[data-pbb-plan]');
      this.submitBtn = this.form.querySelector('[name="add"]');
      this.upgradeInput = this.querySelector('[data-pbb-upgrade]');
      this.onceInput = this.querySelector(`[name="${this.names.purchase}"][value="once"]`);
      this.status = this.querySelector('[data-pbb-status]');
      this.appstleBridge = this.querySelector('[data-pbb-appstle-bridge] input');

      this.state = this.readState();
      this.busyLabel = null;

      this.addEventListener('change', this.handleChange.bind(this));
      this.addEventListener('submit', this.handleSubmit.bind(this), true);
      this.addEventListener('on:cart:add', this.handleAdded.bind(this));
      this.addEventListener('on:line-item:change', this.handleAdded.bind(this));
      this.addEventListener('on:cart:error', this.endBusy.bind(this));
      window.addEventListener('pageshow', this.handlePageShow.bind(this));
      const switchBtn = this.querySelector('[data-pbb-switch-main]');
      if (switchBtn) switchBtn.addEventListener('click', this.switchToMain.bind(this));
      this.moveAfterpay();
      this.guardSubscriptionWidget();
      this.disableUpsellPopup();
      this.render();
    }

    readState() {
      const checked = (name) => this.querySelector(`[name="${name}"]:checked`)?.value;
      const size = checked(this.names.size);
      const qty = Number(checked(this.names.qty));
      return {
        size: size && this.config.options[size] ? size : String(this.config.initial),
        qty: qty >= 1 && qty <= 3 ? qty : this.config.defaultQty,
        upgrade: Boolean(this.config.upgrade && this.upgradeInput && this.upgradeInput.checked),
        sub: checked(this.names.purchase) === 'sub'
      };
    }

    handlePageShow(evt) {
      if (evt.persisted) this.endBusy();
      this.state = this.readState();
      this.render();
    }

    handleSubmit() {
      if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;
      this.setBusy('Adding…');
      this.busyTimer = setTimeout(() => {
        if (this.submitBtn.getAttribute('aria-disabled') !== 'true') this.endBusy();
      }, 10000);
    }

    handleAdded() {
      this.setBusy('Added to cart');
      this.busyTimer = setTimeout(() => this.endBusy(), 1400);
    }

    setBusy(label) {
      clearTimeout(this.busyTimer);
      this.busyLabel = label;
      this.render();
    }

    endBusy() {
      clearTimeout(this.busyTimer);
      if (!this.busyLabel) return;
      this.busyLabel = null;
      this.render();
    }

    handleChange(evt) {
      const input = evt.target;
      if (input.name === this.names.qty) {
        this.state.qty = Number(input.value);
      } else if (input.name === this.names.size) {
        this.state.size = input.value;
      } else if (input === this.upgradeInput) {
        this.state.upgrade = input.checked;
        if (input.checked) this.selectSize(String(this.config.main));
      } else if (input.name === this.names.purchase) {
        this.state.sub = input.value === 'sub';
      } else {
        return;
      }
      this.render();
      this.announce();
    }

    selectSize(variantId) {
      this.state.size = variantId;
      const radio = this.querySelector(`[name="${this.names.size}"][value="${variantId}"]`);
      if (radio) radio.checked = true;
    }

    switchToMain() {
      this.selectSize(String(this.config.main));
      this.render();
      this.submitBtn.focus();
    }

    get option() {
      const id = this.state.upgrade && this.config.upgrade ? this.config.upgrade : this.state.size;
      return this.config.options[String(id)];
    }

    getSelection() {
      const { option } = this;
      const q = option.q[this.state.qty - 1];
      const subAvailable = Boolean(this.config.subscribe && q.sub);
      const sub = this.state.sub && subAvailable ? q.sub : null;
      return {
        option,
        q,
        subAvailable,
        sub,
        total: sub ? sub.total : q.total,
        amount: sub ? sub.amount : q.amount,
        bottles: `${this.state.qty} ${this.config.words[this.state.qty - 1]}`
      };
    }

    render() {
      const sel = this.getSelection();
      const { option } = sel;

      if (this.state.sub && !sel.subAvailable) {
        this.state.sub = false;
        if (this.onceInput) this.onceInput.checked = true;
      }

      this.setText('[data-pbb-title-suffix]', ` · ${option.label}`);

      option.q.forEach((q, i) => {
        this.setText(`[data-pbb-qty-price="${i + 1}"]`, q.total);
        this.setText(
          `[data-pbb-qty-sub="${i + 1}"]`,
          `${q.supply} · ${i === 0 ? option.perDay : this.config.ship[i]}`
        );
      });

      const purchase = this.querySelector('[data-pbb-purchase]');
      if (purchase) {
        purchase.hidden = !sel.subAvailable;
        this.setText('[data-pbb-once-line]', sel.q.total);
        if (sel.q.sub) {
          this.setText('[data-pbb-sub-line]', `${sel.q.sub.total} · ${sel.bottles} every ${sel.q.sub.every}`);
        }
      }

      const sizes = this.querySelector('[data-pbb-sizes]');
      if (sizes) sizes.hidden = this.state.upgrade;

      const small = !this.state.upgrade && this.state.size !== String(this.config.main);
      this.toggle('[data-pbb-popular-card], [data-pbb-popular-badge], [data-pbb-legend-small]', small);
      this.toggle('[data-pbb-upgrade-card], [data-pbb-tag], [data-pbb-legend-main]', !small);
      if (small) this.setText('[data-pbb-popular-per-day]', option.perDay);
      this.labelTag(!small);

      this.idInput.value = option.id;
      this.qtyInput.value = this.state.qty;
      this.planInput.value = sel.sub ? sel.sub.plan : '';
      this.planInput.disabled = !sel.sub;
      if (this.appstleBridge && this.busyLabel !== 'Adding…') this.appstleBridge.value = this.planInput.value;

      this.setText(
        '[data-pbb-cta]',
        this.busyLabel || `Add ${sel.bottles}${sel.sub ? ' · subscribe' : ''} · ${sel.total}`
      );
      this.submitBtn.disabled = !option.available;

      if (this.afterpay) this.afterpay.setAttribute('data-amount', sel.amount);
    }

    setText(selector, text) {
      const el = this.querySelector(selector);
      if (el && el.textContent !== text) el.textContent = text;
    }

    toggle(selector, show) {
      this.querySelectorAll(selector).forEach((el) => {
        el.hidden = !show;
      });
    }

    labelTag(show) {
      const tag = this.querySelector('[data-pbb-tag]');
      const input = this.querySelector('[data-pbb-tag-input]');
      if (!tag || !input) return;
      const ids = input.getAttribute('aria-labelledby').split(' ').filter((id) => id && id !== tag.id);
      input.setAttribute('aria-labelledby', (show ? [...ids, tag.id] : ids).join(' '));
    }

    announce() {
      clearTimeout(this.announceTimer);
      this.announceTimer = setTimeout(() => {
        const sel = this.getSelection();
        const product = this.state.upgrade ? `, ${sel.option.label.replace(/\s*\d+$/, '')}` : '';
        const plan = sel.sub ? `subscribe every ${sel.sub.every}` : 'one-time';
        this.status.textContent = `${sel.bottles}${product}, ${plan}, ${sel.total}`;
      }, 600);
    }

    moveAfterpay() {
      const slot = this.querySelector('[data-pbb-afterpay-slot]');
      const scope = this.closest('.js-product') || document;
      const placement = scope.querySelector('square-placement');
      if (!slot || !placement) {
        if (slot) slot.hidden = true;
        return;
      }
      slot.appendChild(placement.closest('.product-info__block') || placement);
      this.afterpay = placement;
    }

    disableUpsellPopup() {
      window.OCUApi = window.OCUApi || {};
      window.Zipify = window.Zipify || {};
      window.Zipify.OCU = window.Zipify.OCU || { api: window.OCUApi };
      window.Zipify.OCU.api.customAllowUpsellsValidation = () => false;
      window.Zipify.OCU.api.excludeActionButton = 'phloe-buy-box';
    }

    guardSubscriptionWidget() {
      const strip = () => {
        this.querySelectorAll('.appstle_sub_widget:not([data-pbb-appstle-bridge])').forEach((el) => el.remove());
        this.form
          .querySelectorAll('[name="selling_plan"]:not([data-pbb-plan])')
          .forEach((el) => el.remove());
      };
      strip();
      new MutationObserver(strip).observe(this, { childList: true, subtree: true });
    }
  }

  customElements.define('phloe-buy-box', PhloeBuyBox);
}
